import bookmarkAddIcon from "@ms/bookmark_add.svg?raw";
import { Button } from "@ui/Button";
import { toast } from "@ui/molecules/Toasts/toast";
import { useContext } from "solid-js";
import { getBoard } from "@/client";
import {
	AddToBoardContext,
	saveClipErrorTitle,
} from "~/modules/shared/boards/boardsContext";

type Props = {
	onClose: () => void;
	disabled: boolean;
};
export const UpdateBoardItemButton = (props: Props) => {
	const [state, { finishClipSave, saveClipToBoard }] =
		useContext(AddToBoardContext);
	const saveLabel = () => (state.board?.id ? "Save changes" : "Add to board");
	return (
		<Button
			variant="primary"
			disabled={props.disabled}
			symbol="bookmark_add"
			onClick={async () => {
				const targetBoardId = state.selectedBoardId;
				if (targetBoardId === null) {
					toast.info({
						title: "Please select at least one board",
					});
					return;
				}

				const saveResult = await saveClipToBoard(targetBoardId);
				if (saveResult.ok === false) {
					toast.error({ title: saveClipErrorTitle(saveResult.reason) });
					return;
				}

				const { payload } = saveResult;
				const sourceBoardId = payload.sourceBoardId;

				if (sourceBoardId) {
					const newBoard = await getBoard({
						path: { board_id: targetBoardId },
					});
					if (newBoard.response.status === 200) {
						finishClipSave(payload, {
							id: newBoard.data.id,
							title: newBoard.data.title,
						});
					} else {
						finishClipSave(payload);
					}
					toast.success({
						title:
							sourceBoardId === targetBoardId
								? "Clip updated"
								: "Clip moved to board",
					});
				} else {
					finishClipSave(payload);
					toast.success({ title: "Clip added to board" });
				}

				props.onClose();
			}}
		>
			{saveLabel()}
		</Button>
	);
};
